<template>
    <app-layout>
        <div class="row expanded panel-container">
            <div>Notiek autorizācija...</div>
        </div>
    </app-layout>
</template>

<script>
    import AppLayout from '../../../layouts/AppLayout'
    import auth from '../../../api/auth'

    export default {

        props: {
            'provider': {
                type: String,
                required: true
            },
        },

        created() {
            // When callback is formatted with queries before fragment, Vue will not find the params
            if (document.location.search) {
                window.location.replace(window.location.origin + window.location.pathname + window.location.hash + window.location.search);
            }
            // TODO consider moving to router interceptor
            const query = {};
            // for (let p of new URLSearchParams(document.location.search)) {
            //     query[p[0]] = p[1];
            // }
            Object.assign(query, this.$route.query);

            console.log('got callback with params', query);

            auth.callback(this.provider, query)
                .then(response => {
                    console.log('response to callback', response.data)

                    //Check if success, then login. Else redirect to registration.
                    if (response.data.hasOwnProperty('access_token')) {
                        console.log('logging in', response.data)
                        this.$store.dispatch('login', response.data)
                        this.$router.push('/')
                    } else {
                        console.log('forwarding to registration', response.data)
                        this.$store.dispatch('setProvider', response.data)
                        this.$router.push({ name: 'auth.register' })
                    }

                    return response;
                }, response => {
                    console.log('response2 to callback', response)
                    this.$notify({ title: 'Autorizācija neizdevās', text: _.get(response, 'data.message'), type: 'error' });
                    this.$router.push('/');
                    return response;
                })
                .catch(error => {
                    console.log('error', error)
                    this.$notify({ title: 'Autorizācija neizdevās', text: '', type: 'error' });
                    throw error;
                })
        },

        components: { AppLayout }

    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/views/auth/oauth/Callback.vue